import React, { Component } from 'react';
import { connect } from 'react-redux';
import configureStore from '../../../store/configureStore';
import { get_user_profile_details, update_user_profile } from '../../../actions/action-userProfiles';
import Loader from '../../common/Loader';
import { history } from '../../../reducers';
import SidebarWrapper from '../../layout/SidebarWrapper';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import PolicyCard from '../../common/PolicyCard';
import Button from '@material-ui/core/Button';
import CommonDelete from '../../common/CommonDelete';


const store = configureStore();

class UserDetails extends Component {

    constructor() {
        super();
        this.state = {
            userDetails: {},
            errors: ''
        };
    }

    componentDidMount() {
        if (!this.props.auth.isAuthenticated) {
            const path = window.location.pathname;
            history.push(`/login?redirect=${path}`);
            return
        }
        this.fetchDetails();
    }

    componentDidUpdate() {
        console.log("componentDidUpdate");
    }

    async fetchDetails() {
        const path = window.location.pathname.split('/');
        const username = path[path.length - 1];
        const { get_user_profile_details } = this.props;
        await get_user_profile_details(username);
        const { userProfileDetails } = store.getState().userProfile;
        this.setState({
            userDetails: userProfileDetails,
        });
    }

    renderDetails(details) {
        return Object.keys(details).map(function (keyName, keyIndex) {
            return (
                <div key={keyName} className="detailsItem">
                    <div className="detailsKey">
                        {keyName}
                    </div>
                    <div className="detailsValue">
                        {details[keyName]}
                    </div>
                </div>
            )
        });
    }


    render() {
        const { showGlobalLoader } = store.getState().userProfile;
        const { permissions } = store.getState().permission;
        const path = window.location.pathname.split('/');
        const username = path[path.length - 1];
        return (
            <div className="page">
                <SidebarWrapper
                    auth={this.props.auth}
                    permissions={permissions}
                />
                <section className="section">
                    {showGlobalLoader ?
                        <Loader />
                        : <div className="container">
                            <h1>User Details</h1>
                            <CommonDelete
                                id={username}
                                type="userProfile"
                            />
                            {this.state.userDetails.data ?
                                <div >
                                    {this.renderDetails(this.state.userDetails.data)}
                                </div>

                                : 'No user details Found'}
                        </div>}
                </section>
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    userProfile: state.userProfile,
    orgunit: state.orgunit,
    permission: state.permission,
});

const mapDispatchToProps = (dispatch) => ({
    get_user_profile_details: (username) => dispatch(get_user_profile_details(username)),
    // update_user_profile: (payload, username) => dispatch(update_user_profile(payload, username)),

});

export default connect(mapStateToProps, mapDispatchToProps)(UserDetails);

